import "./App.css";
import {
  withStyles,
  createTheme,
  MuiThemeProvider,
  makeStyles,
} from "@material-ui/core/styles";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";
import MainContainer from "./components/MainContainer";
import Scroll from "./components/helperComponents/ScrollToTop";

const breakpoints = createBreakpoints({});

const theme = createTheme({
  palette: {
    primary: {
      main: "#1c4c99",
      dark: "#005bc9",
      light: "#90b6ff",
    },
    secondary: {
      light: "#0066ff",
      main: "#0044ff",
      contrastText: "#ffcc00",
    },
  },
  typography: {
    useNextVariants: true,
    fontFamily: "Quicksand",
  },
  overrides: {
    MuiTimelineItem: {
      missingOppositeContent: {
        [breakpoints.down("sm")]: {
          "&:before": {
            display: "none",
          },
        },
      },
    },
  },
});

const styles = (theme) => ({
  app: {
    textAlign: "center",
    // fontFamily: "Quicksand",
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    color: "#233d62",
    textAlign: "center",
    fontWeight: "500",
    // fontFamily: "Quicksand",
  },
}));

const App = () => {
  const classes = useStyles();

  return (
    <MuiThemeProvider theme={theme}>
      <div className={classes.root}>
        <MainContainer />
      </div>
      <Scroll />
    </MuiThemeProvider>
  );
};

export default withStyles(styles, { withTheme: true })(App);
